import { View } from 'foundations-components/components/View';
import { useCallback, useEffect, useRef } from 'react';
import HsocMerchCardGrid from 'pricing-pages-ui-hsoc/components/HsocMerchCardGrid';
import { HsocV2PageHero } from 'pricing-pages-ui-hsoc/components/HsocV2PageHero';
import { useHsocPublicPricing } from './useHsocPublicPricing';
import { HUBSPOT_ON_CREDITS_PAGE } from '../../components/error-boundary/ErrorBoundaryNames';
import { PublicPageWrapper } from '../../components/PublicPageWrapper';
import { useCurrency } from '../../context/CurrencyContext';
import { HSOC_V2_SCREEN, TRACKING_SOURCES, trackHsocV2PageView, trackTermSelectorInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function HsocPublicPageContent() {
  const {
    displayedCurrencyCode
  } = useCurrency();
  const {
    loading,
    error,
    cards,
    onTermChange: setTerm
  } = useHsocPublicPricing(displayedCurrencyCode);
  const handleTermChange = useCallback(term => {
    setTerm(term);
    trackTermSelectorInteraction({
      action: 'click',
      term,
      trackingSource: TRACKING_SOURCES.MERCH_CARD,
      screen: HSOC_V2_SCREEN
    });
  }, [setTerm]);
  if (error) throw error;
  const showCards = !loading && cards.length > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HsocV2PageHero, {}), showCards && /*#__PURE__*/_jsx(View, {
      padding: "800",
      children: /*#__PURE__*/_jsx(HsocMerchCardGrid, {
        cards: cards,
        onTermChange: handleTermChange
      })
    })]
  });
}
export default function PublicHsocPricingPage() {
  const hasTrackedPageViewRef = useRef(false);
  useEffect(() => {
    if (!hasTrackedPageViewRef.current) {
      hasTrackedPageViewRef.current = true;
      trackHsocV2PageView();
    }
  }, []);
  return /*#__PURE__*/_jsx(PublicPageWrapper, {
    errorBoundaryName: HUBSPOT_ON_CREDITS_PAGE,
    navMarkerName: "HSOC_V2_PAGE",
    metricsRoute: "hubspot-credits",
    chunkName: "public-hsoc-pricing-page",
    children: /*#__PURE__*/_jsx(HsocPublicPageContent, {})
  });
}